<div class="mfa-login-page">

  <div class="mfa-login-container">

    <!-- Regresar -->
    <div class="back-wrapper">
      <button
        type="button"
        class="back-btn"
        (click)="goBack()"
      >
        <i class="fa-solid fa-arrow-left"></i>
        <span>Regresar</span>
      </button>
    </div>

    <!-- Logo -->
    <div class="logo-wrapper">
      <img
        class="blur-up lazyloaded img-logo"
        [src]="logoUrl"
        (error)="onLogoError($event)"
        alt="Logo"
      />
    </div>

    <!-- Título -->
    <h1 class="title">
      Código de autenticación
    </h1>

    <!-- Subtítulo -->
    <p class="subtitle">
      Ingrese el código generado por su aplicación autenticadora.
    </p>

    <!-- Código -->
    <form
      [formGroup]="mfaForm"
      (ngSubmit)="confirmMfa()"
    >

      <div class="code-wrapper">

        <input
          #codeInput
          *ngFor="let controlName of codeControls; let i = index"
          type="text"
          inputmode="numeric"
          maxlength="1"
          [formControlName]="controlName"
          class="code-input"
          (input)="onCodeInput($event, i)"
          (keydown)="onCodeKeyDown($event, i)"
          (paste)="onPaste($event)"
        />

      </div>

      <button
        type="submit"
        class="continue-btn"
        [disabled]="mfaForm.invalid || loading"
      >
        <i
          *ngIf="loading"
          class="fa-solid fa-spinner fa-spin"
        ></i>

        <span>
          {{ loading ? 'Validando...' : 'Continuar' }}
        </span>
      </button>

    </form>

   

  </div>

</div>